import DialogComponent from '@components/shared/Dialog';
import { Button } from '@components/ui/button';
import useGzLog from '@hooks/useGzLog';
import { useScreens } from '@hooks/useScreens';
import React, { useState } from 'react';

interface SyncContentWithLocationButtonProps {
  screenId: string;
}

export const SyncContentWithLocationButton: React.FC<SyncContentWithLocationButtonProps> = ({
  screenId,
}) => {
  const { screens, updateScreen } = useScreens();
  const screen = screens.find(s => s.id === screenId);
  const isContentSynced = screen?.content_synced;
  const [open, setOpen] = useState(false)

  const { log } = useGzLog();

  const handleToggleSync = () => {
    const firstScreenWithContentSynced = isContentSynced ? undefined : screens.find(s => s.content_synced && s.location_id === screen?.location_id);
    const newContentSyncedStatus = !isContentSynced;

    updateScreen({
      screenId,
      data: {
        content_synced: newContentSyncedStatus,
        layout_id: firstScreenWithContentSynced?.layout_id,
        asset_id: firstScreenWithContentSynced?.asset_id,
        playlist_id: firstScreenWithContentSynced?.playlist_id,
        video_id: firstScreenWithContentSynced?.video_id,
      }
    });

    log({
      eventtype: "ContentSyncToggled",
      name: "ContentSyncToggled",
      payload: {
        screenId: screenId,
        screenName: screen?.name || "",
        locationId: screen?.location_id || null,
        contentSynced: newContentSyncedStatus,
      },
    });
  };
  const newSyncStatus = !isContentSynced;
  const action = newSyncStatus ? 'enable' : 'disable';

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        {isContentSynced ? 'Disable Content Sync' : 'Enable Content Sync'}
      </Button>
      <DialogComponent
        closeDialog={() => setOpen(false)}
        isDialogOpen={open}
        dialogInfo={{
          title: `${newSyncStatus ? 'Enable' : 'Disable'} Content Sync`,
          description: `Are you sure you want to ${action} content sync for this screen? This will affect all screens in the same location that have content sync enabled.`,
          dialogType: 'confirm',
          onConfirm: async () => {
            handleToggleSync();
          },
        }}
      />
    </>
  );
};